export default "__VITE_ASSET__hDI6yDtP__"